import { showNotification } from "@/components/notifications/Notifications";
import { Popup } from "@/components/popups/Popup/Popup";
import { apiMain } from "@/common/services";
import "./GifPreferencePopup.scss";
import { IGifPreferencePopupProps } from "@/common/buses/popups/popup-types";
import React, { FormEventHandler, useCallback, useState } from "react";
import { onCloseEditGifPreferencesPopup } from "@/components/popup-dispatcher/PopupDispatcher";
import { GifPreferenceList } from "@/components/manage/GifPreferenceList";

export const GifPreferencePopup: React.FC<IGifPreferencePopupProps> = ({ gifId, sexuality }) => {
  const [selectedSexuality, setSelectedSexuality] = useState(sexuality?.[0] as string);

  const handleClose = useCallback(() => {
    onCloseEditGifPreferencesPopup();
  }, []);

  const handleSubmit: FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();

    try {
      if (gifId) {
        await apiMain.patchGif(gifId, {
          sexuality: selectedSexuality,
        });

        showNotification({
          variant: "success",
          title: `Saved the preference for the ${gifId}`
        });
      }

      handleClose();
    } catch (err) {
      showNotification({
        variant: "error",
        title: `Error with saving preference for the ${gifId}`
      });
    }
  };

  const onPreferenceChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedSexuality(event.target.value);
  }, []);

  const btnProps = {
    variant: 1,
    btnType: "submit",
    formId: "gif-preference-form",
    title: "Save",
    disabled: !selectedSexuality
  };

  return (
    <Popup
      title={`Define Preference for ${gifId} GIF`}
      isOpen={true}
      onClose={handleClose}
      popupClass="GifPreferencePopup"
      btnProps={btnProps}
    >
      <div className="GifPreferencePopup-Cnt">
        <form
          className="GifPreferencePopup-Form"
          onSubmit={handleSubmit}
          id="gif-preference-form"
        >
          <GifPreferenceList onChange={onPreferenceChange} selected={selectedSexuality} />
        </form>
      </div>
    </Popup>
  );
};
